import React from "react";
import Countdown from "../../../../unauth/invitation/Countdown";

export default function SecondSession({ data }) {
  return (
    <div className="mt-15">
      <div className="flex flex-col text-center justify-center items-center ">
        <p className="text-center text-white font-bold text-xl pb-2">
          {data.location1.title}
        </p>
        <a
          target="_blank"
          rel="noopener noreferrer"
          href={data.location1.link}
          className="mt-5 flex justify-center items-center border-2 p-2 rounded-full flex gap-2 px-5 w-[200px]"
        >
          <img
            src="https://www.freeiconspng.com/thumbs/location-icon-png/google-location-icon-16.png"
            alt="location"
            className="w-4 object-contain"
          />
          <p className="text-black font-semibold">Get Direction</p>
        </a>
      </div>
      <Countdown targetDate={data.datetime} />
    </div>
  );
}
